import {Injectable} from '@angular/core';
import {environment} from '@env/environment';
import {AbstractBackendService} from '@app/shared/interfaces/service-classes';
import {MetodologiaCalculoModel} from '@app/shared/models/metodologia-calculo.model';
import {Observable} from 'rxjs';
import {MetodologiaEmisionesCountModel} from '@shared/models/metodologia-emisiones-count.model';

@Injectable()
export class MetodologiasCalculoUserService extends AbstractBackendService<MetodologiaCalculoModel, undefined> {
  buildUrlBase(): string {
    return `${environment.api.admin.metodologiasCalculo.user}`;
  }

  countEmisionesByMetodologiaCalculo(start?: Date, end?: Date): Observable<MetodologiaEmisionesCountModel[]> {
    return this.getHttp().post<MetodologiaEmisionesCountModel[]>(environment.api.cuenta.widgets.metodologiasEmisionesCount, {start, end});
  }
}
